import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";

import { loginRequest } from "../../../authConfig/authConfig";

/**
 * Renders a button which, when selected, will redirect the browser for login
 */
export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      //   console.log(e);
    });
  };
  return (
    <Button
      color="inherit"
      sx={{ fontFamily: "Open Sans" }}
      onClick={handleLogin}
    >
      Sign in
    </Button>
  );
};
